import BenefitInputs from './BenefitInputs';

export default BenefitInputs;
